import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Dashboard/Layout';
import { Login } from './pages/Login';
import { DashboardHome } from './pages/DashboardHome';
import { DomainSetup } from './pages/DomainSetup';
import { DomainDetail } from './pages/DomainDetail';
import { ApiKeys } from './pages/ApiKeys';
import { Settings } from './pages/Settings';
import { AdminFunnel } from './pages/AdminFunnel';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Login mode="signup" />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardHome />} />
          <Route path="domains/new" element={<DomainSetup />} />
          <Route path="domains/:id" element={<DomainDetail />} />
          <Route path="api-keys" element={<ApiKeys />} />
          <Route path="settings" element={<Settings />} />
          <Route path="admin" element={<AdminFunnel />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
